import React from 'react';
import Icon from '../../../components/AppIcon';

const ChapterMarkers = ({ 
  chapters = [],
  currentTime = 0,
  onChapterClick 
}) => {
  return (
    <div className="chapter-markers bg-card rounded-lg border border-border p-6">
      <h3 className="text-lg font-heading font-semibold text-foreground mb-4 flex items-center gap-2">
        <Icon name="List" size={20} color="var(--color-primary)" />
        Главы эпизода
      </h3>
      <div className="chapters-list space-y-2 max-h-80 overflow-y-auto">
        {chapters?.map((chapter, index) => {
          const isActive = currentTime >= chapter?.timestamp && 
            (index === chapters?.length - 1 || currentTime < chapters?.[index + 1]?.timestamp);

          return (
            <button
              key={chapter?.id}
              onClick={() => onChapterClick(chapter?.timestamp)}
              className={`chapter-item w-full flex items-start gap-3 p-3 rounded-lg text-left transition-all duration-200 ${
                isActive 
                  ? 'bg-primary/10 border border-primary/20' :'hover:bg-muted'
              }`}
            >
              <div className={`chapter-number w-8 h-8 rounded-full flex items-center justify-center flex-shrink-0 ${
                isActive ? 'bg-primary text-primary-foreground' : 'bg-muted text-muted-foreground'
              }`}>
                <span className="text-sm font-mono font-medium">{index + 1}</span>
              </div>
              <div className="chapter-content flex-1">
                <div className="flex items-center justify-between mb-1">
                  <h4 className={`text-sm font-heading font-medium ${
                    isActive ? 'text-primary' : 'text-foreground'
                  }`}>
                    {chapter?.title}
                  </h4>
                  <span className="text-xs font-mono text-muted-foreground">
                    {chapter?.formattedTime}
                  </span>
                </div>
                {chapter?.description && (
                  <p className="text-xs text-muted-foreground line-clamp-2">
                    {chapter?.description}
                  </p>
                )}
              </div>
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default ChapterMarkers;